import axios from "axios";

const baseURL = process.env.VUE_APP_BOT_PROSHIP_API || "https://bot-proship.fly.dev";

// Plain axios call on purpose: the app's `http` helper logs the seller out on 401.
export default {
  namespaced: true,
  state: {
    disconnected: [],
    count: 0,
    loaded: false
  },
  getters: {
    count: state => state.count,
    names(state) {
      const list = state.disconnected.map(p => p.name || p.pageId);
      let text = list.slice(0, 3).join(", ");
      if (state.count > 3) text += " และอีก " + (state.count - 3) + "\u00a0เพจ";
      return text;
    }
  },
  mutations: {
    set(state, { disconnected, count }) {
      state.disconnected = disconnected;
      state.count = count;
      state.loaded = true;
    },
    clear(state) {
      state.disconnected = [];
      state.count = 0;
      state.loaded = true;
    }
  },
  actions: {
    // One-time login link (valid ~5 min). Never cached. Resolves to a url string or null.
    getLink({ rootState }) {
      const auth = rootState.user && rootState.user.authData;
      if (!auth || !auth.token) return Promise.resolve(null);
      return axios
        .post(baseURL + "/api/bot/link", null, {
          headers: { Authorization: "Bearer " + auth.token },
          timeout: 15000
        })
        .then(res => (res.data && res.data.success && res.data.url) || null)
        .catch(() => null);
    },
    fetch({ commit, rootState }) {
      const auth = rootState.user && rootState.user.authData;
      if (!auth || !auth.token) return Promise.resolve();
      return axios
        .get(baseURL + "/api/bot/pages/status", {
          headers: { Authorization: "Bearer " + auth.token },
          timeout: 15000
        })
        .then(res => {
          const d = res.data;
          if (d && d.success && d.total > 0 && d.count > 0 && Array.isArray(d.disconnected)) {
            commit("set", { disconnected: d.disconnected, count: d.count });
          } else {
            commit("clear");
          }
        })
        .catch(() => commit("clear"));
    }
  }
};

